import { useCallback, useEffect, useState } from 'react';

export const OTP_RESEND_COOLDOWN_SECONDS = 60;
export const OTP_MAX_RESENDS = 2;

/**
 * Resend gate: call markSent() after every OTP send (first send and resends).
 * markSent(retryAfter) honours a server-supplied wait (seconds) over the default 60.
 * reset() restores the full allowance - call it when the user goes back to the input step.
 */
export default function useOtpResend() {
  const [sends, setSends] = useState(0);
  const [secondsLeft, setSecondsLeft] = useState(0);

  const counting = secondsLeft > 0;
  useEffect(() => {
    if (!counting) return undefined;
    const t = setInterval(() => setSecondsLeft((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, [counting]);

  const markSent = useCallback((retryAfter) => {
    const wait = Number(retryAfter);
    setSends((n) => n + 1);
    setSecondsLeft(wait > 0 ? Math.ceil(wait) : OTP_RESEND_COOLDOWN_SECONDS);
  }, []);

  const reset = useCallback(() => {
    setSends(0);
    setSecondsLeft(0);
  }, []);

  const resendsLeft = Math.max(0, OTP_MAX_RESENDS - Math.max(0, sends - 1));
  const canResend = sends > 0 && secondsLeft === 0 && resendsLeft > 0;
  return { secondsLeft, canResend, resendsLeft, markSent, reset };
}
